import React, { FC, useCallback } from 'react';
import { Empty } from 'antd';

import Button from '../../../Buttons';
import WhaleSpot from 'assets/img/emptySadWhale.svg';

import { Wrapper, Label, EmptyDescriptionBlock } from './styled';
import { AdvancedNotFoundContentProps } from 'ui/components/Select/types';

export const NotFoundContent: FC<Props> = ({
  createNewOptionText,
  onClick,
  search,
  addButtonLabel = 'Добавить',
  emptyDescription = 'Ничего не найдено.',
  additionalDescription = '',
  showCreateNewOptionText = true,
}) => {
  const handleClick = useCallback(() => {
    onClick(search || '');
  }, [search, onClick]);

  return (
    <Wrapper>
      <Empty
        description={
          <EmptyDescriptionBlock>
            <span>{emptyDescription}</span>
            <span>{additionalDescription}</span>
          </EmptyDescriptionBlock>
        }
        image={WhaleSpot}
      />
      {showCreateNewOptionText && (
        <Label>
          {createNewOptionText || 'Добавить новый параметр'}
          <b>&nbsp;«{search}»</b>?
        </Label>
      )}
      <Button onClick={handleClick} type='primary'>
        {addButtonLabel}
      </Button>
    </Wrapper>
  );
};

interface Props extends AdvancedNotFoundContentProps {
  onClick: (str: string) => void;
  createNewOptionText?: string;
  search?: string;
}
